import axios from 'axios';
import { UserActivityLogModel } from '@/shared/model/user-activity-log.model';
import { PrincipalService } from '@/service/principal.service';

const BASE_ADMIN_URL = 'api/admin';

export default class UserMyPageService {
  private principalService = new PrincipalService();

  constructor() {}

  public callApiGetUser(userIdInput?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('api/getUserById')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiChangeUserColorTheme(colorThemeInput: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/changeColorTheme?&colorTheme=' + colorThemeInput)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateUserLanguage(newLanguage: string, contentLanguage = '') {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/changeLanguage?lang=' + newLanguage + '&contentLanguage=' + contentLanguage)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiResetService(userIdInput: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete('/api/briefing/briefingPage/resetAllByUserId?userKey=' + userIdInput)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiDeleteMoreData(userIdInput: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete('/api/admin/users/delele-more-data?userId=' + userIdInput)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  saveUserActivitiesOpenReportDetail(docId: string, language: string) {
    const userActivityLog = new UserActivityLogModel();
    userActivityLog.connectomeId = this.principalService.getConnectomeInfo().connectomeId;
    userActivityLog.userLanguage = language ? language : '';
    userActivityLog.userId = this.principalService.getUserInfo()?.id || '';
    userActivityLog.queryParams = docId;
    userActivityLog.activityName = 'view details';
    const token = this.principalService.getToken();
    if (!token) {
      return;
    }
    axios.post('api/user-activity-log/saveChangeUrl', userActivityLog).then();
  }

  public callApiUpdateToPaidUser() {
    return new Promise<any>((resolve, reject) => {
      axios
        .put('api/admin/users/update-to-paid-user')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  // public callAPICreateInvitationCode(userIdInput: string) {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .post('api/createInvitationCode?userId=' + userIdInput)
  //       .then(res => resolve(res))
  //       .catch(err => reject(err));
  //   });
  // }

  public callAPICancelPayment(paidplanId: number, stripeSubscriptionId: string) {
    if (!paidplanId || !stripeSubscriptionId) return;
    const reqParams = '?paidplanId=' + paidplanId + '&stripeSubscriptionId=' + stripeSubscriptionId;
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/cancel-payment' + reqParams)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateUser(formData) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(BASE_ADMIN_URL + '/updateUser', formData)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
